/* global _TL_ */
import Backbone from 'backbone';
import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'react-jss';
import config from '@bingads-webui-component-legacy/config/index';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { InstrumentationContext } from '@bingads-webui-react/hoc-with-instrumentation';
import { ComponentSettings, ThemeFluent } from '@bingads-webui-theme-2018/theme-fluent';
import { EditDisplayAdWizard, getVerifiedTrackingSettings } from '@bingads-webui-campaign-react/xandr-display-ads-campaign-shared-components';
import { Scenario, Activity } from '@bingads-webui-react/hoc-with-signal';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { PreferenceContext } from '@bingads-webui-react/preference-context';
import { UiBlocker } from '@bingads-webui-react/ui-blocker';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';

export default class View extends Backbone.View {
  initialize({
    scope,
    editMode = false,
    model = {},
    showInline = false,
    instrumentation,
    perfMarker,
    permissions,
    activityLogger,
    campaignId,
    adGroupId,
    serverContext,
    preferenceService,
    triggerCancel,
    triggerClose,
    handleSave,
    isMultiAdFormatAd,
  }) {
    this.aid = _.get(serverContext, ['CurrentAccount', 'Id']);
    this.cid = _.get(serverContext, ['CurrentCustomer', 'Id']);
    this.advertiserCustomerId = _.get(serverContext, ['CurrentAccount', 'AdvertiserCustomerID']);
    this.scope = scope;
    this.editMode = editMode;
    this.showInline = showInline;
    this.perfMarker = perfMarker;
    this.instrumentation = instrumentation;
    this.model = model;
    this.apiErrors = [];
    this.campaignId = campaignId;
    this.adGroupId = adGroupId;
    this.activityLogger = activityLogger;
    this.resetFields = false;
    this.permissions = permissions;
    this.serverErrors = null;
    this.serverContext = serverContext;
    this.preferenceService = preferenceService;
    this.verifiedTrackingSetting = this.editMode ? getVerifiedTrackingSettings(model) : {};
    this.triggerCancel = triggerCancel;
    this.triggerClose = triggerClose;
    this.handleSave = handleSave;
    this.scenario = 'Edit-DisplayAds';
    this.isMultiAdFormatAd = isMultiAdFormatAd;

    this.parentRemove = super.remove;

    this.render();
  }

  onSave(result) {
    return this.handleSave(result.ads.data[0], result.ads.data[0].Id, 'Responsive');
  }

  onSaveAndCreateAnother(result) {
    ReactDOM.unmountComponentAtNode(this.el);
    this.model = null;

    this.render();
    return this.handleSave(result.ads.data[0], result.ads.data[0].Id, 'Responsive');

  }


  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }

  cancel() {
    this.triggerCancel();
    this.triggerClose();
  }

  render() {
    const scenarioName = 'XandrDisplayAdsAdEditing';
    const activityName = 'Ad';

    ReactDOM.render(
      <I18nContext.Provider value={this.options.newI18n}>
        <InstrumentationContext.Provider value={this.instrumentation}>
          <ThemeProvider theme={{ components: ComponentSettings, core: ThemeFluent }}>
            <ScopeContext.Provider value={{ scope: { values: { ...this.scope(), cid: this.cid, aid: this.aid } } }}>
              <Scenario name={scenarioName}>
                <Activity name={activityName}>
                  <ServerContext.Provider value={this.serverContext}>
                    <PreferenceContext.Provider value={this.preferenceService}>
                      <PermissionsContext.Provider value={this.permissions}>
                        <EditDisplayAdWizard
                          perfMarker={this.perfMarker}
                          gridData={this.model}
                          onCancel={_.bind(this.cancel, this)}
                          onSave={_.bind(this.onSave, this)}
                          onSaveAndCreateAnother={_.bind(this.onSaveAndCreateAnother, this)}
                          isMultiAdFormatAd={this.isMultiAdFormatAd}
                        />
                      </PermissionsContext.Provider>
                    </PreferenceContext.Provider>
                  </ServerContext.Provider>
                </Activity>
              </Scenario>
            </ScopeContext.Provider>
          </ThemeProvider>
        </InstrumentationContext.Provider>
      </I18nContext.Provider>
      ,
      this.el,
    );

    return this;

  }
}
